<template>
  <div id="app">
    <el-row>
      <el-col :span="20">
Passo 2 - APRESENTAÇÃO DA EMPRESA

      </el-col>
    </el-row>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" >
       <el-form-item label="Apresentação da Empresa" prop="apresentacao">
        <vue-editor id="apresentacao" v-model="ruleForm.apresentacao"></vue-editor>
      </el-form-item>
 
    </el-form>
    
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
   components: {
    VueEditor,
  },
   data() {
    return {
       ruleForm: {
        apresentacao: "<h1 style='text-align:left;'>APRESENTAÇÃO DA EMPRESA</h1><br><p>A NBRTec Indústria de Equipamentos foi fundata em 25 de Fevereiro de 2005.</p><p>Iniciou sua história com o desenvolvimento de placas e controladores eletrônicos para empresas do município de Panambi, e desde então sempre esteve focada em trazer as soluções requeridas pelos clientes.</p><p>Para isso, sua atuação está fundamentada na inovação, aliando tecnologia e conhecimento técnico para desenvolver e aprimorar seus produtos e serviços.</p><p>Tem como missão 'oferecer ao Agronegócio soluções em Termometria, Automação, Painéis Elétricos Customizados, Instalações Elétricas e Assistência Técnica especializada, solucionando as necessidades dos clientes, gerando resultados satisfatórios.'</p><p>Diante disso, tem como visão 'ser reconhecido como fornecedor com as melhores soluções para os clientes, desenvolvendo relacionamentos duradouros e promovendo assim a sustentabilidade da empresa'.</p><br><br><p>Nome Fantasia: NBRTec Indústria Elétrica</p><p>CNPJ: 07.245.569/0001-66</p><p>Inscrição Estadual: 09000459-06</p>",

       },
    };

  },
  methods: {
  
    }
};
</script>

<style>
#proposta  {
  height: 350px;
}
</style>

